import React, { Fragment } from "react";
import ReactTooltip from "react-tooltip";
import className from "classnames";
const SiderBarElementT1 = (props) => {
  const {
    title,
    handleOnClick,
  } = props;
  return (
    <Fragment>
      <div className={className("sidebar-item pr")}>
        <div onClick={() => {
          handleOnClick()
        }} className="menu-header">
          <span data-tip data-for={title}>
            <span className="sidebar-item-text ml-10 fs-14 fBold pr">
              {title}
            </span>
          </span>

          <ReactTooltip id={title}>
            <span className={"fBold"}>{title}</span>
            <br />
          </ReactTooltip>

        </div>
      </div>
      <div className="separator" />
    </Fragment>
  );
};

export default SiderBarElementT1;
